exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".qrcode{padding:10px 8px;background-color:#fff}.qrcode-text{font-size:14px;color:#21a2f2;margin-top:10px;text-align:center}", "", {"version":3,"sources":["/home/workspace/nr-api-html/master/src/components/public/Qrcode.vue"],"names":[],"mappings":"AACA,QACE,iBAAkB,AAClB,qBAAuB,CACxB,AACD,aACI,eAAgB,AAChB,cAAe,AACf,gBAAiB,AACjB,iBAAmB,CACtB","file":"Qrcode.vue","sourcesContent":["\n.qrcode {\n  padding: 10px 8px;\n  background-color: #fff;\n}\n.qrcode-text {\n    font-size: 14px;\n    color: #21a2f2;\n    margin-top: 10px;\n    text-align: center;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7a6961cb","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/public/Qrcode.vue
// module id = 470
// module chunks = 5 8 11